import { Group } from '@td/membersupport';
import { authToken, teladocApi } from '@td/api';
import { get } from 'lodash'

const fetchGroups = (payerName, rteOnly=false) => {
  return teladocApi.get("groups/permissions_report", {rte_only: rteOnly, q: payerName}, authToken.get()).then( r => {
    return r.data.data
      .map( g => { return Group({
        name: g.group_nm,
        companyName: g.company_nm,
        gateway:  get(g, 'rte_gateways[0].gateway_cd'),
        primaryRegistration: g.primary_cd,
        dependentRegistration: g.dependent_cd,
        effectiveStartDate: g.effective_start_dt,
        cardName: g.card_nm,
        registrationCode: g.username,
      })});
  }).catch( () => {
    return [];
  })
}

export default fetchGroups;
